import React, { useEffect } from 'react'
import { Button, Card, Form, Input, Select } from 'antd'
import { $isSuccessCreate, closeModal, submitCreateUser } from './model'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router-dom'
import { path } from '../../../../libs'
import { User } from './types'
import { $userGroups, groupsListMounted } from '../../groups/list/model'

export const CreateUser = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm<User>()

  const userGroups = useUnit($userGroups)
  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  useEffect(() => {
    groupsListMounted()
  }, [])

  useEffect(() => {
    if (isSuccessCreate) {
      navigate(path.users.entry())
      modalCloseFn()
    }
  }, [isSuccessCreate])

  const onFinish = (values: User) => {
    submitCreateUser(values)
  }

  return (
    <Card title={<strong>Create user</strong>}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: 520 }}
        initialValues={{
          username: '',
          firstName: '',
          lastName: '',
          email: '',
          position: '',
          userGroups: [],
          password: '',
        }}
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Username обязателен' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="First name"
          name="firstName"
          rules={[{ required: true, message: 'Имя обязательно' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Last name"
          name="lastName"
          rules={[{ required: true, message: 'Фамилия обязательна' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[
            { required: true, message: 'Пароль обязателен' },
            {
              min: 8,
              message: 'Пароль должен содержать минимум 8 символов',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Email обязателен' },
            {
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Введите корректный email адрес',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Position" name="position">
          <Input />
        </Form.Item>
        <Form.Item label="User groups" name="userGroups">
          <Select
            mode="multiple"
            allowClear
            options={userGroups.map((g) => ({ value: g.id, label: g.name }))}
            optionFilterProp="label"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}
